import { useState, useEffect, useRef } from 'react';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import { useStore } from '../../utils/store';
import AddButtonComponent from '../../components/form/AddButtonComponent';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';

import HttpServices from '../../services/HttpService';
import Constants from '../../utils/constants';

import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import { useNavigate, useParams } from 'react-router-dom';
import CustomPaginationActionsTable from '../../components/TablePagination';

import TextFieldAreaComponent from '../../components/form/TextFieldAreaComponent';
import ButtonComponent from '../../components/form/ButtonComponent';

const ShiftNotes: React.FC = () => {
  const navigate = useNavigate();
  const isInitialLoad = useRef(true);
  const { crewId, shiftId } = useParams<{ crewId: any; shiftId: any }>();

  const [inProgress, setInProgress] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const { getAdmin } = useStore();
  const [itemData, setItemData] = useState<any[]>([]);
  const [shiftNoteDialogOpen, setShiftNoteDialogOpen] = useState(false);

  const [shiftNoteError, setShiftNoteError] = useState<any>('');
  const [currentNoteId, setCurrentNoteId] = useState<any>(null);
  const [currentNote, setCurrentNote] = useState('');
  const [saving, setSaving] = useState(false);

  const columns: any[] = [
    {
      field: 'note',
      headerName: 'Note',
    },
  ];

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (itemData.length === 0) fetchData();
    }
  }, [shiftId]);

  const fetchData = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.shiftURL}/${shiftId}/note`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          search: '',
          limit: -1,
          offset: 0,
        }
      );
      if (response.success) {
        console.log('ddd');
        setItemData(response.data);
      }
      console.log('GET Response:', response);
      setInProgress(false);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: 'No records found',
        open: true,
      });
      setInProgress(false);
    }
  };

  const handleNoteSave = async () => {
    try {
      if (!currentNote) {
        setShiftNoteError('Note is requied');
        return;
      }
      setSaving(true);
      if (currentNoteId) {
        const apiURL = `${Constants.apiURL}${Constants.shiftURL}/note/${currentNoteId}`;
        await HttpServices.put(
          apiURL,
          {
            note: currentNote,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getAdmin(),
            },
          }
        );
      } else {
        const apiURL = `${Constants.apiURL}${Constants.shiftURL}/${shiftId}/note`;
        await HttpServices.post(
          apiURL,
          {
            note: currentNote,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getAdmin(),
            },
          }
        );
      }

      setAlert({
        type: 'success',
        message: 'Saved Sucessfully',
        open: true,
      });
      handleClose();
      fetchData();
    } catch (e) {
      setSaving(false);
      setAlert({
        type: 'error',
        message: 'Problem with API server',
        open: true,
      });
    }
  };
  const NoteDialogContent = () => {
    return (
      <div className="row mb-3 mt-2">
        <Box sx={{ width: '600px' }}>
          <Box>
            <TextFieldAreaComponent
              name={'notebox_'}
              value={currentNote}
              isRequired={true}
              errorStr={shiftNoteError}
              minRows={7}
              keyName={'notebox_'}
              label="Note"
              onChange={(e: any) => {
                setCurrentNote(e.target.value);
                setShiftNoteError('');
              }}
            />
          </Box>
        </Box>
        <div className="col" style={{ textAlign: 'right', marginTop: '15px' }}>
          <ButtonComponent
            keyName={'addBtn'}
            errors={[]}
            onClick={handleNoteSave}
            loading={saving}
            disabled={saving}
            label={saving ? 'Saving...' : 'Save'}
          />
        </div>
      </div>
    );
  };
  const handleClose = () => {
    setShiftNoteDialogOpen(false);
    setCurrentNote('');
    setCurrentNoteId(null);
    setSaving(false);
  };
  return (
    <Box className="main dashboardmain">
      <Box
        sx={{ width: '100%', padding: '20px' }}
        className="section dashboard"
      >
        <Box
          className="containergrid"
          sx={{
            padding: ' 16px',
          }}
        >
          {
            <Box>
              <Box
                onClick={() => {
                  navigate(
                    '/schedules/crews-schedule/' + crewId + '/' + shiftId
                  );
                }}
                style={{
                  cursor: 'pointer',
                  display: 'inline-flex',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <UTurnLeftIcon
                  sx={{
                    transform: 'rotate(90deg)',
                    cursor: 'pointer',
                  }}
                />
                <Typography>Back</Typography>
              </Box>
              <Paper sx={{ width: '100%', mt: 4 }} className="mt-4">
                <Box
                  sx={{
                    padding: '24px 16px 16px 16px',
                    mb: 2,
                    display: 'grid',
                    gap: '32px',
                    overflowX: 'scroll',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      component={'h6'}
                      sx={{ mt: 4, fontWeight: '500' }}
                    >
                      {'Shift Notes'}
                    </Typography>
                    {inProgress && (
                      <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <CircularProgress sx={{ color: 'rgb(0, 244, 255)' }} />
                      </Box>
                    )}
                    <AddButtonComponent
                      onClick={() => {
                        setShiftNoteDialogOpen(true);
                      }}
                      keyName="checkIcon"
                      label="Add New Note"
                    />
                  </Box>
                  <Box>
                    <CustomPaginationActionsTable
                      rows={itemData}
                      columns={columns}
                      totalRecords={itemData.length}
                      handlePagination={() => {}}
                      handleRowClick={(row) => {
                        setCurrentNote(row.note);
                        setCurrentNoteId(row.id);
                        setShiftNoteDialogOpen(true);
                      }}
                      paginationModel={{
                        page: 0,
                        pageSize: -1,
                      }}
                      handleStatus={() => {}}
                      isPagingHide={true}
                    />
                  </Box>
                </Box>
              </Paper>
            </Box>
          }
        </Box>
        <SimpleDialogComponent
          title={'Shift Note'}
          dialogContent={NoteDialogContent()}
          open={shiftNoteDialogOpen}
          handleClose={handleClose}
        />
        <AlertMessageComponent
          type={alert.type}
          open={alert.open}
          handleClose={handleCloseAlert}
          message={alert.message}
        />
      </Box>
    </Box>
  );
};
export default ShiftNotes;
